enum AvatarDescriptionEnum {
  // K-5
  JOE = "Cartoon image of a smiling, one-eyed, gold monster standing up"
}
export default AvatarDescriptionEnum;
